<ideals-page-message />
<router-outlet>
  <ideals-spinner />
</router-outlet>
